import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import api from '../../../services/API';
import { toast } from 'react-toastify';
import historico from '../../../services/Historico';

export default function ModalEncerrarPontuacao(props) {
  const [encerrando, setEncerrar] = useState(false);
  const encerrarPontuacao = async () => {
    setEncerrar(true);
    const resultado = await api.post('/api/pontuacoes/encerrar', {
      identificador: props.pontuacao,
    });

    if (resultado) {
      toast.success(`Pontuação encerrada com sucesso`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      props.onHide();
      historico.push('/painel/processar/pontuacoes');
    }
    setEncerrar(false);
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Encerrar Pontuação</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="d-flex justify-content-center align-items-center text-center w-100 p-4">
          <span>
            Tem certeza que deseja marcar como encerrado essa pontuação
            pendente?
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center align-items-center w-100">
          {encerrando ? (
            <button
              type="button"
              className="btn btn-success m-1"
              onClick={encerrarPontuacao}
              disabled
            >
              ENCERRANDO...
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-success m-1"
              onClick={encerrarPontuacao}
            >
              ENCERRAR
            </button>
          )}
          <button
            type="button"
            className="btn btn-danger m-1"
            onClick={props.onHide}
          >
            NÃO
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
